<template>
  <div id="unicorn" >
  	<div class="bgdiv" v-html="info"></div>
  </div>

</template>

<script>
import protocoldesc from '@/assets/js/aitry.js';
export default{
	name:'ai',
	data(){
		return {
			info:'',
			status:1
		}
	},
	
	created(){
	document.title = '发现独角兽';
    this.status = this.$route.query.status || 1;
    if(this.status == 1){
      this.info = protocoldesc.iosprivacy;
	

    }else if(this.status == 2){
      this.info = protocoldesc.iosserve;
	  document.title = '发现独角兽-用户协议';
    }
		// this.status = this.$route.query.status || 1;
	}
}



</script>
<style lang='scss'>
#unicorn{
	font-size:15px;
	width:100%;
	height:100%;
	position:absolute;
	overflow-y:auto;
	-webkit-overflow-scrolling: touch;
	.bgdiv{
		padding:10px;
		p{
			font-size:16px;
			line-height: 26px;
			margin:0 10px;
		}
	}
}
</style>
